import { DossierSettings, SectionName, useGetDossierSettings } from "@/entities/dossier-settings";
import { PropsWithChildren, useCallback, useMemo } from "react";
import { SectionsContext, SectionsContextType } from "./sections-context";

type SectionsProviderProps = {
    dossierId: string;
};

export function SectionsProvider({ children, dossierId }: Readonly<PropsWithChildren<SectionsProviderProps>>) {
    const { data: dossierSettings, isPending, error } = useGetDossierSettings(dossierId);

    const isSectionEnabled = useCallback(
        (sectionName: SectionName) => {
            if (!dossierSettings) return false;
            return DossierSettings.isSectionEnabled(dossierSettings, sectionName);
        },
        [dossierSettings]
    );

    const isSectionInUse = useCallback(
        (sectionName: SectionName) => {
            if (!dossierSettings) return false;
            return DossierSettings.isSectionInUse(dossierSettings, sectionName);
        },
        [dossierSettings]
    );

    const contextValue = useMemo(
        (): SectionsContextType => ({
            isSectionEnabled,
            isSectionInUse,
            isPending,
            error: error ?? null,
        }),
        [isSectionEnabled, isSectionInUse, isPending, error]
    );

    return <SectionsContext value={contextValue}>{children}</SectionsContext>;
}
